var SIZE_TO_CLASSNAME_MAP = {
    s: 'size-500',
    500: 'size-500',
};

export { SIZE_TO_CLASSNAME_MAP };
